export enum BundleStatusReason {
  unknown = 'unknown',
  targetFailed = 'targetFailed',
  targetDropped = 'targetDropped',
  searcherTxFrontrun = 'searcherTxFrontrun',
  searcherTxLate = 'searcherTxLate',
}
